import {Injectable, inject} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {map, Observable} from 'rxjs';
import {AUTHENTICATION_SERVICE} from 'src/app/shared/services/authentication/authentication.service';
import {PrudentPlusAuthenticationService} from '../services/prudent-plus-authentication.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetGuard implements CanActivate {
  private authenticationService = inject<PrudentPlusAuthenticationService>(AUTHENTICATION_SERVICE);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.authenticationService.isLoggedIn().pipe(
      map((isLoggedIn) => {
        if (isLoggedIn) {
          this.router.navigate([
            'dashboard',
            'home',
          ]);
        }

        return !isLoggedIn;
      })
    );
  }
}
